import { type LucideIcon } from 'lucide-react';
import { type ReactNode } from 'react';

type Props = {
  icon: LucideIcon;
  title: string;
  description?: string;
  action?: ReactNode;
};

export function EmptyState({ icon: Icon, title, description, action }: Props) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-6">
      <div className="h-12 w-12 rounded-sm border border-border-strong flex items-center justify-center mb-5">
        <Icon size={18} className="text-text-dim" />
      </div>
      <h3 className="font-display text-lg text-text mb-2">{title}</h3>
      {description && (
        <p className="text-sm text-text-muted max-w-sm mb-6 leading-relaxed">{description}</p>
      )}
      {action}
    </div>
  );
}
